export enum UserSort {
  InstitutionName = 1,
  UserName = 2,
  UserOib = 3,
  UserRole = 4
}